<template>
  <div>
    <div class="pt-md-3">
      <b-row>
        <b-col v-if="hasTitle">
          <h5>
            {{ tableTitle }}
          </h5>
        </b-col>
        <b-col cols="6">
        </b-col>
        <b-col v-if="hasFilter">
          <b-form-group label="Φίλτρο Πίνακα" label-for="filter-input" label-cols-sm="4" label-align-sm="right"
                        label-size="md" class="mb-0">
            <b-input-group>
              <b-form-input id="filter-input" v-model="filter" type="search" placeholder="Αναζήτηση"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Καθαρισμός</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="hasContent">
        <b-col class="pt-2">
          <span v-html="tableContent"></span>
        </b-col>
      </b-row>
      <b-table :thead-class="hasHeader ? '' : 'd-none'"
               :striped="striped"
               :bordered="bordered"
               :borderless="borderless"
               :outlined="outlined"
               :small="small"
               :hover="hover"
               :dark="dark"
               :fixed="fixed"
               :foot-clone="footClone"
               :no-border-collapse="noCollapse"
               :items="tableItems"
               :fields="fields"
               :head-variant="headVariant"
               :table-variant="tableVariant"
               :filter="filter"
               :filter-included-fields="filterOn"
               :current-page="currentPage"
               :per-page="perPage"
               :sort-by.sync="sortBy"
               :sort-desc.sync="sortDesc"
               :sort-direction="sortDirection"
               :select-mode="selectMode"
               :busy="isBusyC"
               responsive sticky-header stacked="md" show-empty
               @filtered="onFiltered"
               :sort-compare="sortCompare"
               ref="selectableTable"
               selectable
               @row-selected="onRowSelected"
               class="pt-2"
               :emptyText="emptyText">
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Παρακαλώ περιμένετε...</strong>
          </div>
        </template>
        <template v-for="(field, index) in model.fields" v-slot:[`head(${field.key})`]="data">
          <span :key="index" v-html="data.label"/>
        </template>
        <template v-for="(field,index) in model.fields" v-slot:[`cell(${field.key})`]="data">
          <template v-if="field.component === 'index'">
            <span :key="index" :class="field.className"> {{ data.index + 1 }}</span>
          </template>
          <template v-if="field.component === 'b-form-datepicker'">
            <span :key="index" :class="field.className">
              {{ !isEmpty(data.value) ? data.value : '-' }}
            </span>
          </template>
          <template v-else-if="field.component === 'b-form-select'">
            <span :key="index" :class="field.className">
              {{ !isEmpty(data.value) ? data.value[field.text] : '-' }}
            </span>
          </template>
          <template v-else-if="field.component === 'b-form-select-datalist'">
            <span :key="index" :class="field.className">
              {{ !isEmpty(data.value) ? data.value[field.text] : '-' }}
            </span>
          </template>
          <template v-else-if="field.component === 'b-form-checkbox'">
            <span :key="index" :class="field.className">
              {{ !isEmpty(data.value) ? data.value == 1 ? 'Ναι' : ' Όχι' : '-' }}
            </span>
          </template>
          <template v-else>
            <span :key="index" :class="field.className">
              {{ !isEmpty(data.value) ? data.value : '-' }}
            </span>
          </template>
        </template>
        <template #empty="scope">
          <div class="text-center"> {{ scope.emptyText }}</div>
        </template>
        <template #cell(index)="data">
          {{ (data.index + 1) + (perPage * (currentPage - 1)) }}
        </template>
        <template #cell(name)="row">
          {{ row.value.first }} {{ row.value.last }}
        </template>
        <!-- Example scoped slot for select state illustrative purposes -->
        <template #cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
      </b-table>
      <b-row no-gutters>
        <b-col class="mr-auto p-2">
          <div v-if="!isInternal">
            <b-button v-if="supportReportView && !isExternal" :disabled="Boolean(disableReportButton(selected))"
                      style="background-color: rgba(109,73,203,0.71)"
                      class="mr-2 mt-2" @click="onReport(selected[0])">
              <p class="h8 mb-0">
                <b-icon-file-earmark-text class="pr-1"></b-icon-file-earmark-text>
                Προβολή Δήλωσης(pdf)
              </p>
            </b-button>

            <b-button v-if="supportTaxisReload && !isExternal" variant="primary"
                      class="mr-2 mt-2" @click="onTaxisReload()">
              <p class="h mb-0">
                <b-icon-plus-square-dotted class="pr-1"></b-icon-plus-square-dotted>
                Προσθήκη από TAXIS
              </p>
            </b-button>

            <b-button v-if="supportDownload && !isExternal" :disabled="Boolean(disableDownloadButton(selected))"
                      variant="primary" class="mr-2 mt-2" @click="onDownload(selected[0])">
              <p class="h8 mb-0">
                <b-icon-file-earmark-text class="pr-1"></b-icon-file-earmark-text>
                Προβολή Εγγράφου
              </p>
            </b-button>

            <b-button v-if="supportEdit && !isExternal" :disabled="selected.length == 0" variant="info"
                      class="mr-2 mt-2" @click="onEditForm(selected[0])">
              <p class="h8 mb-0">
                <b-icon-pencil class="pr-1"></b-icon-pencil>
                Επεξεργασία
              </p>
            </b-button>
            <b-button v-if="supportCreate && !isExternal" variant="success" class="mr-2 mt-2" @click="onCreateForm">
              <p class="h8 mb-0">
                <b-icon-plus-square-dotted></b-icon-plus-square-dotted>&nbsp;
                Προσθήκη
              </p>
            </b-button>
            <b-button v-if="supportDelete && !isExternal" :disabled="selected.length == 0" variant="danger"
                      class="mr-2 mt-2" @click="onDeleteForm(selected[0])">
              <p class="h8 mb-0">
                <b-icon-trash class="pr-1"></b-icon-trash>
                Διαγραφή
              </p>
            </b-button>
            <b-button v-if="supportGeneralButtonNavigation" :disabled="isGeneralButtonDisabledNavigation"
                      :variant=generalButtonVariantNavigation
                      class="mr-2 mt-2" @click="onNavigation(selected[0])">
              <p class="h8 mb-0">
                <b-icon :icon="generalButtonIconNavigation" class="mr-1"></b-icon>
                {{ generalButtonLabelNavigation }}
              </p>
            </b-button>
            <b-button v-if="supportGeneralButton" :disabled="isGeneralButtonDisabled" :variant=generalButtonVariant
                      class="mr-2 mt-2" @click="onclick(selected[0])">
              <p class="h8 mb-0">
                <b-icon :icon="generalButtonIcon" class="mr-1"></b-icon>
                {{ generalButtonLabel }}
              </p>
            </b-button>
            <b-button v-if="supportDocView && !isExternal" :disabled="selected.length == 0"
                      :variant="docViewButtonVariant" class="mr-2 mt-2" @click="onDocView(selected[0])">
              <p class="h8 mb-0">
                <b-icon :icon="docViewButtonIcon" class="mr-1"></b-icon>
                {{ docViewButtonLabel }}
              </p>
            </b-button>
          </div>
          <div v-if="isInternal">
            <b-button v-if="supportTaxisReload  && !isExternal" variant="primary"
                      class="mr-2 mt-2" @click="onTaxisReloadInternal(selected[0])">
              <p class="h mb-0">
                <b-icon-arrow-clockwise class="pr-1"></b-icon-arrow-clockwise>
                Ενημέρωση από TAXIS
              </p>
            </b-button>
            <b-button v-if="supportEdit  && !isExternal" :disabled="selected.length <= 0" variant="info"
                      class="mr-2 mt-2" @click="onEditFormInternal(selected[0])">
              <p class="h8 mb-0">
                <b-icon-pencil class="pr-1"></b-icon-pencil>
                Επεξεργασία
              </p>
            </b-button>
            <b-button v-if="supportCreate && !isExternal" variant="success" class="mr-2 mt-2"
                      @click="onCreateFormInternal">
              <p class="h8 mb-0">
                <b-icon-plus></b-icon-plus>&nbsp;
                Προσθήκη
              </p>
            </b-button>
            <b-button v-if="supportDelete && !isExternal" :disabled="selected.length <= 0" variant="danger"
                      class="mr-2 mt-2" @click="onDeleteFormInternal(selected[0])">
              <p class="h8 mb-0">
                <b-icon-trash class="pr-1"></b-icon-trash>
                Διαγραφή
              </p>
            </b-button>
            <b-button v-if="supportGeneralButton && !isExternal" :disabled="selected.length <= 0"
                      :variant=generalButtonVariant
                      class="mr-2 mt-2" @click="onClickInternal(selected[0])">
              <p class="h8 mb-0">
                <b-icon-arrow-clockwise class="pr-1"></b-icon-arrow-clockwise>
                {{ generalButtonLabel }}
              </p>
            </b-button>
          </div>
        </b-col>
        <template v-if="hasPagination">
          <b-col align-self="start" class="mr-auto p-2">
            <b-form-group label="Ανα σελίδα" label-for="per-page-select" label-cols-lg="auto" label-align-lg="right"
                          label-size="sm" class="mb-0 pl-2">
              <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions" size="sm"
                             style="max-width: 80px"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col align-self="end" xs="2" lg="auto" class="p-2">
            <b-pagination v-model="currentPage" :total-rows="totalTableRows" :per-page="perPage"
                          align="fill"></b-pagination>
          </b-col>
        </template>
      </b-row>
      <div v-if="isExternal">
        <b-button v-if="supportReportView" :disabled="disableReportButton(selected)"
                  style="background-color: rgba(109,73,203,0.71)"
                  class="mr-2 mt-2" @click="onReport(selected[0])">
          <p class="h8 mb-0">
            <b-icon-file-earmark-text class="pr-1"></b-icon-file-earmark-text>
            Προβολή Δήλωσης(pdf)
          </p>
        </b-button>
        <b-button v-if="supportDocView" :disabled="disableDocButton(selected[0])"
                  variant="success" class="mr-2 mt-2" @click="onDocView(selected[0])">
          <p class="h8 mb-0">
            <b-icon :icon="docViewButtonIcon" class="mr-1"></b-icon>
            {{ docViewButtonLabel }}
          </p>
        </b-button>
        <b-button v-if="supportEdit" v-b-modal.modal-1 :disabled="disableEditAndDeleteButton(selected)" variant="info"
                  class="mr-2 mt-2"
                  @click="onEdit(selected[0])">
          <p class="h8 mb-0">
            <b-icon-pencil class="pr-1"></b-icon-pencil>
            Επεξεργασία Δήλωσης
          </p>
        </b-button>
        <b-button v-if="supportChange" :disabled="disableCorrectionButton(selected)" variant="warning"
                  class="mr-2 mt-2" @click="onChange(selected[0])">
          <p class="h8 mb-0">
            <b-icon-arrow-repeat class="pr-1"></b-icon-arrow-repeat>
            Διόρθωση Δήλωσης
          </p>
        </b-button>
        <b-button v-if="supportDelete" :disabled="disableEditAndDeleteButton(selected)" variant="danger"
                  class="mr-2 mt-2" @click="onDelete(selected[0])">
          <p class="h8 mb-0">
            <b-icon-trash class="pr-1"></b-icon-trash>
            Διαγραφή Δήλωσης
          </p>
        </b-button>
      </div>
    </div>
    <BaseBFormModal ref="modal" @handle-submit="onSubmit" @handle-delete="onDelete" @handle-valid="onValid"
                    :model="model" :hasHeader="hasFormModalHeader" :size="formModalsize"/>
  </div>
</template>

<script>

import {tableVisibility} from "@/util/ComponentUtils";
import {formatDateGRDefault} from "@/util/ConvertDateUtil";
import {getCaption, isEmpty} from "@/util/Helpers";
import BaseBFormModal from "@/components/base/BaseBFormModal.vue";

export default {
  name: "BaseBTable",
  components: {BaseBFormModal},
  props: {
    model: {
      default: () => {
      },
      require: true,
      type: Object
    },
    sortCompare: {
      default: () => {
      },
      require: false,
      type: Function
    },
    items: {
      default: () => [],
      require: true,
      type: Array
    },
    tableTitle: {
      default: 'Όνομα Πίνακα',
      require: false,
      type: String
    },
    tableContent: {
      default: 'Περιοχόμενο subtitle για τον πίνακα',
      require: false,
      type: String
    },
    hasHeader: {
      default: true,
      require: false,
      type: Boolean
    },
    formModalsize: {
      default: () => 'xl',
      require: false,
      type: String
    },
    hasFormModalHeader: {
      default: () => false,
      require: false,
      type: Boolean
    },
    hasFilter: {
      default: true,
      require: false,
      type: Boolean
    },
    hasPagination: {
      default: true,
      require: false,
      type: Boolean
    },
    hasTitle: {
      default: true,
      require: false,
      type: Boolean
    },
    hasContent: {
      default: false,
      require: false,

    },
    isBusy: {
      default: false,
      require: false,
      type: Boolean
    },
    noCollapse: {
      default: true,
      require: false,
      type: Boolean
    },
    selectMode: {
      default: 'single',
      require: false,
      type: String
    },
    striped: {
      default: true,
      require: false,
      type: Boolean
    },
    bordered: {
      default: true,
      require: false,
      type: Boolean
    },
    borderless: {
      default: false,
      require: false,
      type: Boolean
    },
    outlined: {
      default: true,
      require: false,
      type: Boolean
    },
    small: {
      default: false,
      require: false,
      type: Boolean
    },
    hover: {
      default: true,
      require: false,
      type: Boolean
    },
    dark: {
      default: false,
      require: false,
      type: Boolean
    },
    fixed: {
      default: false,
      require: false,
      type: Boolean
    },
    footClone: {
      default: false,
      require: false,
      type: Boolean
    },
    /**
     * headVariant:
     *      'light',
     *       'dark'
     */
    headVariant: {
      default: null,
      require: false,
      type: String
    },
    /**
     *  tableVariants:
     *         'primary',
     *         'secondary',
     *         'info',
     *         'danger',
     *         'warning',
     *         'success',
     *         'light',
     *         'dark'
     */
    tableVariant: {
      default: null,
      require: false,
      type: String
    },
    isExternal: {
      default: false,
      require: false,
      type: Boolean
    },
    isInternal: {
      default: false,
      require: false,
      type: Boolean
    },
    supportCreate: {
      default: true,
      require: false,
      type: Boolean
    },
    supportEdit: {
      default: true,
      require: false,
      type: Boolean
    },
    supportDelete: {
      default: true,
      require: false,
      type: Boolean
    },
    supportReportView: {
      default: false,
      require: false,
      type: Boolean
    },
    supportTaxisReload: {
      default: false,
      require: false,
      type: Boolean
    },
    supportDownload: {
      default: false,
      require: false,
      type: Boolean
    },
    supportGeneralButton: {
      default: false,
      require: false,
      type: Boolean
    },
    generalButtonVariant: {
      default: 'warning',
      require: false,
      type: String
    },
    generalButtonLabel: {
      default: '',
      require: false,
      type: String
    },
    generalButtonIcon: {
      default: 'arrow-clockwise',
      require: false,
      type: String
    },
    generalButtonDisable: {
      default: true,
      require: false,
      type: Boolean
    },
    supportGeneralButtonNavigation: {
      default: false,
      require: false,
      type: Boolean
    },
    generalButtonVariantNavigation: {
      default: 'warning',
      require: false,
      type: String
    },
    generalButtonIconNavigation: {
      default: 'arrow-return-right',
      require: false,
      type: String
    },
    generalButtonLabelNavigation: {
      default: '',
      require: false,
      type: String
    },
    generalButtonDisableNavigation: {
      default: true,
      require: false,
      type: Boolean
    },
    supportChange: {
      default: true,
      require: false,
      type: Boolean
    },
    supportDocView: {
      default: false,
      require: false,
      type: Boolean
    },
    docViewButtonVariant: {
      default: 'success',
      require: false,
      type: String
    },
    docViewButtonIcon: {
      default: 'file-earmark-text',
      require: false,
      type: String
    },
    docViewButtonLabel: {
      default: 'Έγγραφα Δήλωσης',
      require: false,
      type: String
    }
  },
  watch: {
    tableItems() {
      this.init();
    }, deep: true
  },
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      currentIndex: 0,
      perPage: this.hasPagination ? 10 : 1000,
      pageOptions: [5, 10, 15, {value: 1000, text: "Όλα"}],
      filter: null,
      filterOn: [],
      selected: [],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc'
    }
  },
  beforeDestroy() {
    this.totalRows = null
    delete this.totalRows
    this.currentPage = null
    delete this.currentPage
    this.currentIndex = null
    delete this.currentIndex
    this.perPage = null
    delete this.perPage
    this.pageOptions = null
    delete this.pageOptions
    delete this.model
  },
  computed: {
    isBusyC() {
      return this.isBusy
    },
    isGeneralButtonDisabled() {
      return Boolean(this.generalButtonDisable)
    },
    isGeneralButtonDisabledNavigation() {
      return Boolean(this.generalButtonDisableNavigation)
    },
    totalTableRows() {
      return this.totalRows
    },
    tableItems() {
      return this.init()
    },
    fields() {
      return tableVisibility(this.model.fields)
    },
    emptyText() {
      return getCaption('LABEL_EMPTY_TABLE')
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return {text: f.label, value: f.key}
          })
    }
  },

  created() {
    this.totalRows = !isEmpty(this.items) ? this.items.length : 0
  },

  methods: {
    isEmpty,
    init() {
      this.model.fields.forEach(field => {
        if (Object.prototype.hasOwnProperty.call(field, 'tableValue')) {
          field[field['tableValue']] = field['tableValue']
          if (!isEmpty(this.items)) {
            this.items.forEach(x => {
              if (Object.prototype.hasOwnProperty.call(field, 'static')) {
                x[field['tableValue']] = x[field.desc]
              } else {
                x[field['tableValue']] = x[field.key][field.textField]
              }
            })
          }
        }
      })
      this.totalRows = !isEmpty(this.items) ? this.items.length : 0
      return this.items
    },
    disableDownloadButton(selected) {
      return selected.length == 0 && isEmpty(selected)
    },
    disableDocButton(selected) {
      if (!isEmpty(selected)) {
        if (!isEmpty(selected.arProtokolou)) {
          return false
        }
      }
      return true
    },
    disableReportButton(selected) {
      return selected.length == 0 && isEmpty(selected)
    },
    disableEditAndDeleteButton(selected) {
      if (!isEmpty(selected[0]) && selected.length > 0) {
        return !isEmpty(selected[0].hmOristiko) && !isEmpty(selected[0].arProtokolou)
      } else {
        return true
      }
    },
    disableCorrectionButton(selected) {
      if (!isEmpty(selected) && selected.length > 0) {
        return isEmpty(selected[0].hmOristiko) && isEmpty(selected[0].arProtokolou)
      } else {
        return true
      }
    },

    callFormatDate(value) {
      return formatDateGRDefault(value);
    },
    onSubmit(item) {
      if (!isEmpty(item)) {
        let result = this.$refs.modal.onValid(item)
        item.formResult.result = result.result
        item.formResult.errors = result.errors
        this.$emit("handle-submit", item);
      }
    },
    onDelete(item) {
      if (!isEmpty(item)) {
        this.$emit("handle-delete", item);
      }
    },

    onCreate() {
      console.log('onCreate')
      this.$emit("handle-create", this.model.model.form);
    },

    onEdit(item) {
      console.log('onEdit-table')
      this.$emit("handle-edit", item);
    },
    onChange(item) {
      console.log('onChange-table')
      this.$emit("handle-change", item);
    },
    onReport(item) {
      this.$emit("handle-report", item);
    },
    onDownload(item) {
      this.$emit("handle-download", item);
    },
    onDocView(item) {
      this.$emit("handle-doc-view", item);
    },
    onCreateForm(item) {
      try {
        console.log('onCreateForm')
        this.$nextTick(() => {
          this.$refs.modal.onCreate(this.model.form)
        })
        this.$emit("handle-create", this.model.form)
      } catch (e) {
        console.log(e)
      }
    },

    onDeleteForm(item) {
      let index = this.tableItems.indexOf(item)
      if (this.selected.length > 0 && index !== -1) {
        this.currentIndex = index
      }
      this.$refs.modal.openDeletePopUp(item, this.currentIndex)
    },

    onEditForm(item) {
      this.$emit("handle-edit", item)
      let index = this.tableItems.indexOf(item)
      if (this.selected.length > 0 && index !== -1) {
        this.currentIndex = index
      }
      this.$refs.modal.onEdit(item, this.currentIndex)
    },

    onclick(item) {
      this.$emit("handle-general-button", item);
    },
    onTaxisReload() {
      this.$emit("handle-taxis");
    },
    onNavigation() {
      this.$emit("handle-navigation");
    },

    onCreateFormInternal() {
      this.$emit("handle-submit-internal", this.model.model.form)
      this.$refs.modal.onCreateInternal(this.model.model.form)
    },

    onDeleteFormInternal(item) {
      this.$emit("handle-delete", item)
      let index = this.tableItems.indexOf(item)
      if (this.selected.length > 0 && index !== -1) {
        this.currentIndex = index
      }
      this.$refs.modal.openDeletePopUp(item, this.currentIndex)
    },

    onEditFormInternal(item) {
      this.$emit("handle-edit", item)
      let index = this.tableItems.indexOf(item)
      if (this.selected.length > 0 && index !== -1) {
        this.currentIndex = index
      }
      this.$refs.modal.onEditInternal(item, this.currentIndex)
    },

    onClickInternal(item) {
      this.$emit("handle-general-button", item);
    },

    onRowSelected(item) {
      // if (item.length > 0) {
      this.selected = item
      this.$emit("handle-row-select", item);
      // }
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    /* Checks the validity of the form */
    onValid(item) {
      // this.onEditFormInternal(item.formResult.form)
      let result = {result: false > 0, errors: []}
      try {
        if (!isEmpty(this.$refs.modal)) {
          result = this.$refs.modal.onValid(item)
        }
        return result
      } catch (e) {
        console.log(e)
        return result
      }
    },
  }
}
</script>

<style scoped>
/*.panel-heading {*/
/*  background: #fafafa;*/
/*  border-bottom: 2px solid #ececec;*/
/*  padding: 11px 20px 9px;*/
/*  position: relative;*/
/*}*/
/* Busy table styling */
table.b-table[aria-busy='true'] {
  opacity: 0.6;
}
</style>
